<template>
  <div id="app">
   <router-view  ref="child"></router-view> 
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  name: 'App',
  mounted () {
    window.screenWidth = document.body.clientWidth;
    if (window.screenWidth < 769) {
      this.$store.commit("GET_DEVICE_TYPE", true);
    } else {
      this.$store.commit("GET_DEVICE_TYPE", false);
    }
    console.log(this.$store.state.isMobile)
    // window.addEventListener("resize",()=>{  //全局监听窗口变化
    //     this.resize();
    // });
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth;
        if (window.screenWidth < 769) {
          this.$store.commit("GET_DEVICE_TYPE", true);
        } else {
          this.$store.commit("GET_DEVICE_TYPE", false);
        }
      })()
    }
  },
  methods:{
    resize(){
       try{
          if(typeof(eval(this.$refs.child.callResize))=="function"){
             
              this.$refs.child.callResize();
          }
        }catch(e){
        }
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" >
#app {
  // min-width: 1200px;
  margin: 0 auto;
  font-family: "Microsoft YaHei", "微软雅黑", "PingFang SC";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 14px;
  -webkit-text-size-adjust:none;
  input {
    -webkit-user-select: text;
  }
}
@media (max-width: 768px) {
  #app {
    width: 100%;
  }
}
@media (min-width: 769px) {
  #app {
    min-width: 1200px;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue